// order-domain: ownership=shared copyPolicy=keep-shared pruneAfter=never
import { isMagicbuyProject } from './projectUtils'

// 生产实际激活集合的唯一来源；M5 保持 prepare=[]，M6 按平台原子更新。
export const ACTIVE_CREATE_PROJECTS = Object.freeze(['mgb-h5', 'mgb-pc'])

const CREATE_NAMESPACE = Object.freeze({
  kkren: 'jyo/jyorderCreate',
  mgb: 'jyo/jyorderCreateMgb',
})

const CREATE_ROUTE = Object.freeze({
  create: Object.freeze({ kkren: 'KkrenOrderCreate', mgb: 'MgbOrderCreate' }),
  choseTrade: Object.freeze({ kkren: 'KkrenOrderCreateChoseTrade', mgb: 'MgbOrderCreateChoseTrade' }),
})

function resolveBrand (project) {
  return isMagicbuyProject(project) && ACTIVE_CREATE_PROJECTS.includes(project) ? 'mgb' : 'kkren'
}

function routeByKind (kind) {
  const route = CREATE_ROUTE[kind]
  if (!route) throw new Error(`未知下单路由类型: ${kind}`)
  return route
}

export function resolveCreateNs (project) {
  return CREATE_NAMESPACE[resolveBrand(project)]
}

export function resolveCreateRoute (project, kind = 'create') {
  return routeByKind(kind)[resolveBrand(project)]
}

export function resolveCreateComponentName (project, kind = 'create') {
  if (kind === 'choseTrade') return null
  return routeByKind(kind)[resolveBrand(project)]
}

export function getCreateStoreAccess (store, project) {
  const namespace = resolveCreateNs(project)
  return {
    namespace,
    get state () {
      return namespace.split('/').reduce((state, key) => state?.[key], store.state)
    },
    getter: name => store.getters[`${namespace}/${name}`],
    commit: (type, payload) => store.commit(`${namespace}/${type}`, payload),
    dispatch: (type, payload) => store.dispatch(`${namespace}/${type}`, payload),
  }
}
